export default {"src":"/_next/static/media/fire.612dd1de.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};